import { fetchWithAuth } from '../utils/fetchWithAuth';

const BASE = '/regional-workers';

// LISTA PLANA
export async function listRegionalWorkers({ entityId, officeId, q } = {}) {
  const params = new URLSearchParams();
  if (entityId) params.set('entityId', entityId);
  if (officeId) params.set('officeId', String(officeId));
  if (q) params.set('q', q);
  const res = await fetchWithAuth(`${BASE}?${params.toString()}`, { method: 'GET' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || `HTTP ${res.status}`);
  return Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
}

// ÁRBOL por oficina
export async function listRegionalWorkersTree(entityId, officeId) {
  const res = await fetchWithAuth(`${BASE}/tree?entityId=${entityId}&officeId=${officeId}`, { method: 'GET' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || `HTTP ${res.status}`);
  return Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
}

// OBTENER UNO
export async function getRegionalWorker(id) {
  const res = await fetchWithAuth(`${BASE}/${id}`, { method: 'GET' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || `HTTP ${res.status}`);
  return data?.data ?? data;
}

// CREAR
export async function createRegionalWorker(payload) {
  const res = await fetchWithAuth(BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || `HTTP ${res.status}`);
  return data;
}

// ACTUALIZAR
export async function updateRegionalWorker(id, payload) {
  const res = await fetchWithAuth(`${BASE}/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || `HTTP ${res.status}`);
  return data;
}

// ELIMINAR (maneja 404 sin romper la UI)
export async function deleteRegionalWorker(id) {
  const res = await fetchWithAuth(`${BASE}/${id}`, { method: 'DELETE' });
  if (res.status === 404) return false; // no existe en backend (prob. registro legado)
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.message || `HTTP ${res.status}`);
  }
  return true;
}
